export default __webpack_public_path__ + "static/media/chile.fd28461a.png";